import React from "react";
import clsx from "clsx/lite";

const iFrame = ({ data }) => (
	<div className="md:px-7">
		<div className="w-full relative m-auto">
			<iframe src={data.src}
				className={clsx("inset-0 w-full z-10", data?.largerHeight ? "h-[1950px] sm:h-[1650px] xl:h-[1550px]" : "h-[720px]")}
			/>
		</div>
	</div>
);

export default iFrame;
